import { useState, useEffect } from "react";
import {
  FaCog,
  FaUsers,
  FaBox,
  FaShoppingCart,
  FaClipboardList,
  FaChartPie,
  FaBook,FaPlus,FaFistRaised,FaUndo,
  FaDoorOpen,FaCar,FaSearch,FaBiohazard,
} from "react-icons/fa";
import { TbGridScan } from "react-icons/tb"
import { MdQrCodeScanner } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
const menuItems = [

  { name: "Avis de recherche", icon: <FaSearch />, color: "bg-gray-100",page:"../avispage" },
  { name: "Journal des controles", icon: <TbGridScan />, color: "bg-gray-100",page:"../check" },
  // { name: "Historique des controleurs", icon: <FaUndo />, color: "bg-yellow-900",page:"../avispage" },


];

export default function Menucheckpoint() {


  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full max-w-screen-xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 pt-28 pb-8 text-black">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
        {menuItems.map((item, index) => (
          <Link to={item.page} key={index} className="transition hover:scale-[1.02]">
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.35, delay: index * 0.06 }}
              className={`w-full h-28 sm:h-32 md:h-36 px-4 sm:px-6 py-4 flex flex-col items-center justify-center rounded-xl shadow-lg cursor-pointer ${item.color}`}
            >
              <div className="text-2xl sm:text-3xl">{item.icon}</div>
              <span className="mt-2 text-center text-xs sm:text-sm md:text-base font-semibold uppercase">
                {item.name}
              </span>
            </motion.div>
          </Link>
        ))}
      </div>
    </div>
  );
}
